export { default as AboutView } from './AboutView';
export { default as AppNotificationView } from './AppNotificationView';
export { default as CaseStudiesView } from './CaseStudiesView';
export { default as CaseStudiesVisualExpiriencesView } from './CaseStudiesVisualExpiriencesView';
export { default as ContactUsView } from './ContactUsView';
export { default as DownloadBrochureView } from './DownloadBrochureView';
export { default as FaqView } from './FaqView';
export { default as FooterView } from './FooterView';
export { default as FreeTrialView } from './FreeTrialView';
export { default as GetInTouchView } from './GetInTouchView';
export { default as HaveQuestionsView } from './HaveQuestionsView';
export { default as HeaderView } from './HeaderView';
export { default as HeroView } from './HeroView';
export { default as HowItWorksView } from './HowItWorksView';
export { default as LearnMoreView } from './LearnMoreView';
export { default as LearnTestExportView } from './LearnTestExportView';
export { default as NewView } from './NewView';
export { default as NewsPageView } from './NewsPageView';
export { default as OurClientsView } from './OurClientsView';
export { default as PriceCardsView } from './PriceCardsView';
export { default as PricingView } from './PricingView';
export { default as QuotesView } from './QuotesView';
export { default as SamplesView } from './SamplesView';
export { default as SeeHowView } from './SeeHowView';
export { default as TaggisAndDocBrowserView } from './TaggisAndDocBrowserView';
export { default as TrialOfferView } from './TrialOfferView';
export { default as UploadVisualsView } from './UploadVisualsView';
export { default as WatchTaggisView } from './WatchTaggisView';
export { default as WhoWeAreView } from './WhoWeAreView';



// WEBPACK FOOTER //
// ./src/components/views/index.js